import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const ApplicationStore = namespace('application');

@Component
export default class BaseMixin extends Vue {

    @ApplicationStore.Mutation('setNavigationTitle')
    public setNavigationTitle!: (payload: {title: string}) => void;

}
